import SubscribeForm from "@/components/feature/SubscribeForm";
import { siteInfo } from "@/mocks/topics";

export default function CtaSection() {
  return (
    <section id="contact" className="w-full bg-background-50">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-8 px-4 py-12 md:px-8 md:py-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">
            保持联系
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            不想错过下一份完整复盘
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            订阅后，每当有事件的时间线梳理完成，你会收到一封简要的更新邮件。
            我们也欢迎你反馈信息错误或补充线索，让每一份复盘更接近事实。
          </p>

          <div className="mt-6 flex items-start gap-3 rounded-lg border border-background-200 bg-background-100 p-5">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
              <i className="ri-mail-send-line text-xl"></i>
            </span>
            <div>
              <h3 className="font-heading text-sm font-bold text-foreground-950">联系与反馈邮箱</h3>
              <p className="mt-1 text-sm text-foreground-600">{siteInfo.email}</p>
              <p className="mt-1 text-xs text-foreground-500">{siteInfo.contactNote}</p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <SubscribeForm />
        </div>
      </div>
    </section>
  );
}